import { Skeleton } from "@mui/material";
import { lazy, Suspense } from "react";

const ReactPlayerLoader = lazy(() => import("@brightcove/react-player-loader"));

interface BrightcoveVideoPlayerProps {
  accountId: string;
  playerId: string;
  videoId: string;
  poster?: string;
  onFailure?: () => void;
}

// Clone of the lexical-editor BrightcoveVideoPlayer for the VOD authoring
// preview: only the account/player ids cached at site selection are available.
export function BrightcoveVideoPlayer({
  accountId,
  playerId,
  videoId,
  poster,
  onFailure,
}: BrightcoveVideoPlayerProps): JSX.Element {
  return (
    <Suspense fallback={<Skeleton variant='rectangular' width='100%' height='100%' />}>
      <ReactPlayerLoader
        attrs={{ className: "brightcove-player" }}
        accountId={accountId}
        videoId={videoId}
        playerId={playerId}
        options={{
          fluid: false,
          fill: true,
          autoplay: false,
          playsInline: true,
          responsive: true,
          preload: "auto",
          controls: true,
          ...(poster ? { poster } : {}),
        }}
        onFailure={onFailure}
      />
    </Suspense>
  );
}
